import cn from 'classnames';
import { ReactNode } from 'react';
// CSS
import styles from './tooltip.module.css';

export interface TooltipProps {
	id: string;
	testId?: string;
	show?: boolean;
	children: ReactNode;
}

/**
 * Tooltip component that displays a tooltip with optional visibility.
 *
 * The parent component must be relative positioned.
 */
const Tooltip = (props: TooltipProps) => {
	const { testId = 'Tooltip', show = false, children, id } = props;

	return (
		<span
			id={id}
			data-testid={testId}
			className={cn(
				'absolute -top-1/2 left-1/2 z-10 origin-center -translate-x-1/2 transition-all duration-300',
				{
					[`${styles['show']} -top-full`]: show,
					[`${styles['hide']} -top-3/4`]: !show,
				},
			)}
		>
			{children}
		</span>
	);
};

export default Tooltip;
